import React from 'react';
import InputGroup from '../../InputGroup';
import cardHelper from 'creditcards/card';
import PropTypes from 'prop-types';

import { Field } from 'redux-form';

const setCarotPosition = ev => {
    setTimeout(() => {
        var target = ev.target;
        var value = target.value;
        target.selectionStart = target.selectionEnd = value.length;
    }, 50);
};

const CreditCardInput = props => (
    <Field
        name="cardNumber"
        component={InputGroup}
        normalize={value => cardHelper.format(value)}
        parse={value => cardHelper.parse(value)}
        type="tel"
        label="Credit card number"
        placeholder="Credit Card Number"
        autocomplete="cc-number"
        autoFocus={props.autoFocus}
        onChange={ev => setCarotPosition(ev)}
    />
);

CreditCardInput.propTypes = {
    autoFocus: PropTypes.bool
};

export default CreditCardInput;



// WEBPACK FOOTER //
// ./src/components/Donation/Form/CreditCardInput.jsx